export default __webpack_public_path__ + "static/aws-icon-13-37371c0bfe55e77b38e8bdda0d638275.svg";